<template>
<div class="pt-4 px-4" data-cy="container_test_main">
    <button data-cy="btn_test_register_success" @click="registerSuccess()" class="mb-7 w-full text-center text-white bg-a-blue-2140a6">Register Success popup</button>
    <button data-cy="btn_test_redeem_success" @click="redeemSuccess()" class="mb-7 w-full text-center text-white bg-a-blue-2140a6">Redeemed popup</button>
    <button data-cy="btn_test_redeem_point_success" @click="redeemPointSuccess()" class="mb-7 w-full text-center text-white bg-a-blue-2140a6">Redeemed Point popup</button>
    <button data-cy="btn_test_error_code" @click="errorCode()" class="mb-7 w-full text-center text-white bg-a-blue-2140a6">Error Code</button>
    <button data-cy="btn_test_starbuck" @click="starbuck()" class="mb-7 w-full text-center text-white bg-a-blue-2140a6">starbuck</button>
</div>
</template>
<script>
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin";
import ModalMixin from '@/mixin/ModalMixin';
export default {
    name: "TestPage",
    mixins: [AuthPageMixin, LocaleMixin, ModalMixin],
    components: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        registerSuccess: function(){
            this.modal.alertModal
                .clearModal()
                .setTitle(this.lbl.modal.register.title)
                .setMsg(this.lbl.modal.register.msg)
                .setBtnOk(this.lbl.modal.btn)
                .show();
        },
        redeemSuccess: function(){
            this.modal.alertModal
                .clearModal()
                .setTitle(this.lbl.modal.redeemed.title)
                .setMsg(this.lbl.modal.redeemed.msg)
                .setBtnOk(this.lbl.modal.btn)
                .show();
        },
        redeemPointSuccess: function(){
            this.modal.alertModal
                .clearModal()
                .setTitle(this.lbl.modal.point.title)
                .setMsg(this.lbl.modal.point.msg)
                .setBtnOk(this.lbl.modal.btn)
                .show();
        },
        errorCode: function(){
            this.modal.errorModal
                .clearModal()
                .setTitle(this.lbl.modal.err_code.title)
                .setMsg(this.lbl.modal.err_code.msg)
                .setBtnOk(this.lbl.modal.btn)
                .show();
        },
        starbuck: function(){
            this.modal.freeStarbuckModal
                .clearModal()
                .setSerial('6204157089064028')
                .setBtnOk('Back')
                .show();
        }
    },

}
</script>
<style lang="scss" scoped>
</style>
